import { Localization } from '../../../interfaces'
import en from './en.json'
import es from './es.json'
import pt from './pt.json'
import zh from './zh.json'
import ar from './ar.json'
import he from './he.json'
import th from './th.json'

const defaultTexts: Record<Localization, typeof en> = {
  [Localization.En]: en,
  [Localization.Es]: es,
  [Localization.Pt]: pt,
  [Localization.Ar]: ar,
  [Localization.EnUs]: en,
  [Localization.EsMx]: es,
  [Localization.PtBr]: pt,
  [Localization.ZhCn]: zh,
  [Localization.Zh]: zh,
  [Localization.He]: he,
  [Localization.Th]: th,
}

export default defaultTexts
